"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var logger = __importStar(require("../logger/logger"));
var crux_state_1 = __importStar(require("./state/crux-state"));
var domains_1 = require("./domains");
var displayName = 'Crux';
var initialized = false;
var set = function (inLocationHost, inIsMainPage, inForceDomain, inConfig, externalState) {
    if (inLocationHost === void 0) { inLocationHost = 'undefined_site_domain'; }
    if (inIsMainPage === void 0) { inIsMainPage = false; }
    if (inForceDomain === void 0) { inForceDomain = ''; }
    if (inConfig === void 0) { inConfig = {}; }
    if (externalState === void 0) { externalState = false; }
    if (!externalState && initialized) {
        // eslint-disable-next-line no-console
        console.error('Uniform initialized multiple times');
        // eslint-disable-next-line no-underscore-dangle
        if (typeof window !== 'undefined' && window.__wpjsdebug__) {
            var __wpjsdebug__ = window.__wpjsdebug__;
            __wpjsdebug__.hasUniform = __wpjsdebug__.hasUniform || 0;
            __wpjsdebug__.hasUniform += 1;
        }
        // @ts-ignore
        if (global && global.process && global.process.exit) {
            process.exit(-1);
        }
        else {
            throw new Error('Uniform initialized multiple times');
        }
    }
    initialized = true;
    logger.debug(displayName, 'set', inLocationHost, inIsMainPage, inForceDomain, inConfig, externalState);
    var state = externalState ? crux_state_1.default : __assign({}, crux_state_1.defaultState);
    var randomHost = 'www.wp.pl';
    var advHosts = ['dynacrems'];
    Object.assign(state, inConfig);
    // ustawiam hosta dla zasobow aplikacji
    state.locationHost = inLocationHost;
    // czy jest strona glowna, istotne przy kodowaniu linkow zewn.
    state.isMainPage = inIsMainPage;
    // czy serwis wspiera AAB server-side
    state.isReady = new RegExp("^(".concat(advHosts.concat(domains_1.aabDomains, domains_1.uniformDomains, domains_1.pixelDomains).join('|'), ")")).test(state.locationHost);
    // czy serwis wspiera AAB server-side na domenie zewn.
    if (!state.isReady && domains_1.aabDomainsExternal[state.locationHost]) {
        // serwis wspiera AAB server-side
        state.isReady = true;
        // mapowanie na domene wp.pl
        state.locationHost = domains_1.aabDomainsExternal[state.locationHost];
    }
    // jezeli serwis jest AAB server-side
    if (state.isReady) {
        // host aplikacji to host serwisu
        state.applicationHost = state.testDomain || inForceDomain || state.locationHost;
    }
    else {
        // host aplikacji to host losowy AAB
        state.applicationHost = state.testDomain || inForceDomain || randomHost;
    }
    // jezeli serwis jest AAB server-side i nie jest strona glowna
    if (state.isReady && !state.isMainPage) {
        // host targetow to host serwisu
        state.targetHost = state.testDomain || inForceDomain || state.locationHost;
    }
    else {
        // host targetow to host losowy AAB
        state.targetHost = state.testDomain || inForceDomain || randomHost;
    }
    if (!externalState) {
        Object.keys(crux_state_1.default).forEach(function (key) {
            crux_state_1.default[key] = state[key];
        });
        return state.enabled;
    }
    return state;
};
exports.default = set;
